<template>
  <div>
    <div class="f-inline-group">
      <legend
        :class="{ 'f-field__label--required' : isRequired }"
        class="f-field__label"
      >
        {{ $t(`fields.record.${fieldName}.label`) }}
      </legend>
      <div
        v-if="$te(`advancedsearch.fields.${fieldName}.description`)"
        class="f-field__tooltip"
      >
        <Tooltip>
          <p>
            {{ $t(`advancedsearch.fields.${fieldName}.description`) }}
          </p>
        </Tooltip>
      </div>
    </div>
    <div class="f-field">
      <div class="f-inline-group">
        <div class="f-field-advanced-search__controller-select">
          <select
            v-model="modelValue.option"
            class="f-field__input f-field__input--select"
            @change="$emit('change', value)"
          >
            <option
              v-for="opt in ['any', 'none']"
              :key="fieldName + opt"
              :value="opt"
            >
              {{ $t(`advancedsearch.fields.enum.options.${opt}`) }}
            </option>
          </select>
        </div>
        <EnumTagsField
          v-model="modelValue.value"
          :record-type="recordType"
          :field-name="fieldName"
          :validator-name="validatorName"
          :is-required="isRequired"
          :component-idx="componentIdx"
          @change="$emit('change', modelValue)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { MetadataUtils } from '@scholar/metadata-utils/main'
import EnumTagsField from '#src/components/advanced-search/fields/EnumTagsField.vue'
import Tooltip from '#src/components/utils/Tooltip.vue'

export default {
  components: {
    EnumTagsField,
    Tooltip
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    recordType: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    validatorName: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    componentIdx: {
      type: Number,
      required: true
    },
    displayType: {
      type: String,
      default: 'valueAndTranslation'
    },
    hideTooltip: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  data() {
    return {
      parser: new MetadataUtils().getParserByType(this.recordType)
    }
  },
  created() {
    if (this.modelValue.value === null) {
      this.modelValue.value = []
    }
    if (this.modelValue.option === null) {
      this.modelValue.option = 'any'
    }
  },
  methods: {
    async validate(val) {
      let validation = await this.parser.validateByField(this.validatorName || this.fieldName, val)
      if (!this.isRequired) {
        validation = { status: true }
      }
      this.modelValue.isValid = validation.status
    }
  }
}
</script>
